module.exports = __webpack_public_path__ + "static/media/yourChoice.b3cfc09e.mp3";